import React from 'react';
import { motion } from 'framer-motion';

const TechWhyChoose = ({ title, description, stats = [], imageUrl, imageAlt }) => {
  return (
    <section
      className="py-24 px-6 relative overflow-hidden"
      style={{ backgroundColor: '#ffffff', color: '#001534' }}
    >
      <div className="max-w-[1240px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-20 items-center">

          {/* Left — Content */}
          <motion.div
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.7, ease: 'easeOut', delay: 0.2 }}
            viewport={{ once: true }}
          >
            {/* Heading */}
            <h2 className="text-2xl md:text-4xl font-bold leading-tight mb-5" style={{ color: "#001534" }}>
              {title}
            </h2>

            {/* Description */}
            <p className="text-md leading-relaxed mb-8" style={{ color: '#475569', hyphens: 'none' }}>
              {description}
            </p>

            {/* Minimalist Stats with vertical divider */}
            <div className="flex gap-12 flex-wrap mt-8">
              {stats.map((stat, index) => (
                <React.Fragment key={index}>
                  <div className="min-w-[160px]">
                    <div
                      className="text-5xl font-semibold leading-none mb-3"
                      style={{
                        background: 'linear-gradient(135deg, #00c6ff 0%, #0072ff 100%)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        backgroundClip: 'text',
                      }}
                    >
                      {stat.value}
                    </div>
                    <div
                      className="text-xs font-bold uppercase tracking-wider"
                      style={{ color: '#475569' }}
                    >
                      {stat.label}
                    </div>
                  </div>
                  {/* Vertical divider (hide after last item) */}
                  {index < stats.length - 1 && (
                    <div
                      className="w-px self-stretch my-2 hidden md:block"
                      style={{ backgroundColor: 'rgba(0, 21, 52, 0.12)' }}
                    />
                  )}
                </React.Fragment>
              ))}
            </div>
          </motion.div>

          {/* Right — Image */}
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.7, ease: 'easeOut' }}
            viewport={{ once: true }}
          >
            <div
              className="relative rounded-3xl overflow-hidden"
              style={{ border: '1px solid rgba(0, 21, 52, 0.08)', boxShadow: '0 8px 32px rgba(0, 0, 0, 0.08)' }}
            >
              <img
                src={imageUrl}
                alt={imageAlt}
                className="w-full h-[400px] object-cover block rounded-3xl transition-transform duration-500 hover:scale-[1.03]"
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default TechWhyChoose;
